import Component from '../core/Component'
import { createModal } from './Modal'
import CourseState from '../meta/CourseState'
import { lang } from '../core/config'

export default class ChatOpener extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault()

        const position = this.element.dataset.position
        const lessons = Object.entries(CourseState.state.lessons)
            .map(entry => ({
                id: entry[0],
                lesson: entry[1]
            }))

        let id = 0
        let allChats = null

        const courseList = Component.getFromElement('course-list')
        if (courseList) {
            allChats = courseList.ref.items.map(item => ({
                id: item.dataset.id,
                groupId: item.dataset.groupId,
                url: item.dataset.chatUrl
            }))
        }

        if (position === 'start') {
            if (allChats) {
                id = allChats[0].id
            } else {
                id = lessons[0].id
            }
        }

        if (position === 'continue') {
            const available = allChats.filter(chat => {
                if (chat.id in CourseState.state.lessons && CourseState.state.lessons[chat.id].completed === false) {
                    return true
                }

                if (!(chat.id in CourseState.state.lessons)) {
                    return true
                }

                return false
            })

            if (available.length === 0) {
                return
            }

            id = available[0].id
        }

        if (position === 'next') {
            const current = this.element.dataset.current
            const currentChat = allChats.find(chat => chat.id === current)

            // search in same group first
            const sameGroup = allChats
                .filter(chat => chat.groupId === currentChat.groupId)

            const sameGroupId = this.getNextAvailableChat(currentChat, sameGroup)
            const allGroupsId = this.getNextAvailableChat(currentChat, allChats)

            if (sameGroupId !== null) {
                id = sameGroupId
            } else if (allGroupsId !== null) {
                id = allGroupsId
            }

            if (id === 0) {
                return
            }
        }

        const chatUrl = allChats.find(item => item.id === id).url

        createModal({
            url: chatUrl,
            autoOpen: true,
            className: 'chat-Modal',
            chatId: id,
            filterResponse: html => {
                const buffer = document.createElement('div')
                buffer.innerHTML = html
                const content = buffer.querySelector('[data-modal-content]')
                return content.innerHTML
            }
        })
    }

    getNextAvailableChat(current, chats) {
        const currentIndex = chats.findIndex(chat => chat.id === current.id)
        let next = 0
        let id = null

        for (let i = 1; i < chats.length; i++) {
            next = (currentIndex + i) % chats.length

            const nextId = chats[next].id

            if (nextId in CourseState.state.lessons && CourseState.state.lessons[nextId].completed === false) {
                id = nextId
                break
            }

            if (!(nextId in CourseState.state.lessons)) {
                id = nextId
                break
            }
        }

        return id
    }
}